import { CobranzasAxios, COMPANY } from './config'

export const getSerie = async () => {
  const res = await CobranzasAxios.get(`/serie/${COMPANY}`)
  return res.data
}

export const postSerie = async (data) => {
  const res = await CobranzasAxios.post(`/serie/${COMPANY}`, data)
  return res.data
}

export const putSerie = async (idSerie, data) => {
  const res = await CobranzasAxios.put(`/serie/${idSerie}`, data)
  return res.data
}
